<div class="confirm-action-dialog">
  <div class="dialog-accent-bar"></div>

  <div class="dialog-body">
    <h2 mat-dialog-title>{{ title }}</h2>

    <mat-dialog-content>
      <p class="dialog-message">{{ textToDisplay }}</p>

      @if (items && items.length) {
        <mat-list dense class="scrollable-dialog-list">
          @for (item of items; track item) {
            <mat-list-item>{{ item.name }}</mat-list-item>
          }
        </mat-list>
      }
    </mat-dialog-content>

    @if (buttonsInfo) {
      <mat-dialog-actions>
        @if (buttonsInfo.denyText) {
          <button mat-stroked-button mat-dialog-close (click)="unconfirmDelete()">{{ buttonsInfo.denyText }}</button>
        }
        @if (buttonsInfo.confirmText) {
          <button mat-raised-button color="{{ buttonsInfo.confirmBtnColor }}" (click)="confirmDelete()">{{ buttonsInfo.confirmText }}</button>
        }
      </mat-dialog-actions>
    }
  </div>
</div>
